import { Eye, StickyNote, Wifi } from "lucide-react";
import { StatusBadge, TierBadge, PaidBadge } from "./badges";

export const InquiriesTable = ({ inquiries, onSelect }) => (
  <div className="mt-6 border border-white/10 overflow-x-auto">
    <table data-testid="inquiries-table" className="w-full text-left text-sm">
      <thead className="bg-[#0B1035] text-slate-400 uppercase text-xs tracking-widest">
        <tr>
          <th className="px-4 py-3">Organization</th>
          <th className="px-4 py-3">Contact</th>
          <th className="px-4 py-3 hidden md:table-cell">Services</th>
          <th className="px-4 py-3 hidden lg:table-cell">Timeline</th>
          <th className="px-4 py-3">Status</th>
          <th className="px-4 py-3 hidden sm:table-cell">Received</th>
          <th className="px-4 py-3"></th>
        </tr>
      </thead>
      <tbody>
        {inquiries.map((i) => (
          <tr key={i.id} data-testid={`inquiry-row-${i.id}`} className="border-t border-white/10 hover:bg-white/[0.03] transition-colors cursor-pointer" onClick={() => onSelect(i)}>
            <td className="px-4 py-3 font-medium text-white">
              <span className="flex items-center gap-2 flex-wrap">
                {i.org_name}
                <TierBadge tier={i.lead_tier} score={i.lead_score} />
                <PaidBadge count={i.paid_count} total={i.paid_total} />
                {i.inquiry_type === "connectivity" && (
                  <span data-testid={`connectivity-tag-${i.id}`} className="inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-widest bg-violet-400/10 text-violet-300 border border-violet-400/30 rounded-full px-2.5 py-0.5">
                    <Wifi className="w-3 h-3" /> Connectivity
                  </span>
                )}
                {(i.notes || []).length > 0 && (
                  <span data-testid={`note-count-${i.id}`} className="inline-flex items-center gap-1 text-xs text-violet-300/80">
                    <StickyNote className="w-3 h-3" /> {i.notes.length}
                  </span>
                )}
              </span>
            </td>
            <td className="px-4 py-3 text-slate-300">{i.full_name}<span className="block text-xs text-slate-500">{i.email}</span></td>
            <td className="px-4 py-3 hidden md:table-cell text-slate-400">{(i.services || []).length} selected</td>
            <td className="px-4 py-3 hidden lg:table-cell text-slate-400">{i.decision_timeline || "—"}</td>
            <td className="px-4 py-3"><StatusBadge status={i.status || "new"} /></td>
            <td className="px-4 py-3 hidden sm:table-cell text-slate-500">{new Date(i.created_at).toLocaleDateString()}</td>
            <td className="px-4 py-3 text-right">
              <button data-testid={`view-inquiry-${i.id}`} onClick={(e) => { e.stopPropagation(); onSelect(i); }}
                className="text-cyan-400 hover:text-cyan-300 transition-colors"><Eye className="w-4 h-4" /></button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
